export default __webpack_public_path__ + "static/PMG_EGIB_MYRUMAH_PDS_AGENCY_ENG-f2eb4a22151bbf8c5906c6d49da34f45.pdf";